// extracted by mini-css-extract-plugin
export default {"outlet":"[planId]_outlet__D2VpS","title":"[planId]_title__CDeeU"};